import React, { useEffect, useState } from "react";
import { Camera, ExternalLink, MapPin } from "lucide-react";
import { api } from "../lib/api";

export default function DossierStreetView({ dossier }) {
  const [geo, setGeo] = useState(null);
  const ex = dossier.extraction || {};
  const addr = [ex.adresse, ex.code_postal, ex.ville].filter(Boolean).join(" ");

  useEffect(() => {
    let alive = true;
    api.get(`/dossiers/${dossier.id}/geo`).then((r) => alive && setGeo(r.data)).catch(() => alive && setGeo({}));
    return () => { alive = false; };
  }, [dossier.id, addr]);

  const has = geo?.lat && geo?.lng;
  const embed = has ? `https://maps.google.com/maps?layer=c&cbll=${geo.lat},${geo.lng}&cbp=12,0,0,0,0&output=svembed` : null;
  const open = has ? `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${geo.lat},${geo.lng}` : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addr)}`;

  return (
    <div className="card-flat p-0 h-full overflow-hidden flex flex-col" data-testid="street-view-card">
      <div className="px-5 pt-4 pb-3 flex items-center justify-between">
        <div className="overline flex items-center gap-1.5"><Camera className="w-3 h-3" /> Street View</div>
        <a href={open} target="_blank" rel="noreferrer" className="text-xs text-norea-textMuted hover:text-norea-primary inline-flex items-center gap-1" data-testid="street-view-open-link">
          Ouvrir <ExternalLink className="w-3 h-3" />
        </a>
      </div>
      <div className="flex-1 min-h-[220px] bg-norea-bg relative">
        {embed ? (
          <iframe title="Street View" src={embed} className="absolute inset-0 w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-testid="street-view-iframe" />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center text-xs text-norea-textMuted gap-1" data-testid="street-view-empty">
            <MapPin className="w-5 h-5" />
            {geo ? "Adresse introuvable — vérifiez l'adresse du client." : "Localisation…"}
          </div>
        )}
      </div>
      {geo?.label && <div className="px-5 py-2 text-[11px] text-norea-textMuted truncate border-t border-norea-border" data-testid="street-view-address">{geo.label}</div>}
    </div>
  );
}
